@if (!isLoading()) {
  <app-profile-form [userData]="userData()" [isEditing]="false">
    <div class="row g-3 w-100 m-0" view-actions>
      <div class="col-12 col-sm-6 col-lg-3 d-grid">
        <button type="button" class="btn btn-secondary" routerLink="edit">
          <i class="bi bi-person-gear me-2"></i>
          Modifica dati
        </button>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 d-grid">
        <button type="button" class="btn btn-primary" routerLink="/events/mine">
          <i class="bi bi-calendar-event me-2"></i>
          I miei Eventi
        </button>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 d-grid">
        <button type="button" class="btn btn-primary" routerLink="/tables/mine">
          <i class="bi bi-dice-5 me-2"></i>
          I miei Tavoli
        </button>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 d-grid">
        <button type="button" class="btn btn-primary" routerLink="/organizations/mine">
          <i class="bi bi-people me-2"></i>
          Le mie Organizzazioni
        </button>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 d-grid">
        <button type="button" class="btn btn-outline-danger" (click)="authService.logout()" id="profileLogoutBtn">
          <i class="bi bi-box-arrow-right me-2"></i>
          Logout
        </button>
      </div>
    </div>
  </app-profile-form>
}
